import { useRouter } from "next/router";
import { logBugsnagError } from '../lib/bugsnag'
import { AppContext } from "../provider/AppContextProvider";
import React from "react";

type RouterFunction = (url: string, shallow?: boolean) => Promise<boolean>;
type RouterFunctionSync = (url: string, shallow?: boolean) => boolean;

export function sanitizeUrl(url: string, appVersion: string): string {
  if(url.indexOf("[id]") > 0) {
    console.log(`sanitizeUrl [id]: ${url}`);
    logBugsnagError(new Error(url), (event) => {
      event.addMetadata('App', {
        appVersion: appVersion
      })
    })
    url = url.replace('/article/[id]', '/').replace('/ressort/[id]', '/')
  }

  if(process?.env?.NEXT_PUBLIC_BACKEND_URL && url.indexOf(process.env.NEXT_PUBLIC_BACKEND_URL) >= 0) {
    console.log(`sanitizeUrl backendUrl: ${url}`);
    // logBugsnagError(new Error(url))
    url = url.replace(process.env.NEXT_PUBLIC_BACKEND_URL, '')
  }
  
  return url;
};

// —— updated hook —— //
export function useLoggedRouter(): [RouterFunction, RouterFunction, RouterFunctionSync, string] {
  const { appVersion } = React.useContext(AppContext);
  const router = useRouter();

  // wrap push so it returns the router promise
  const routerPush = React.useCallback(async (url: string, shallow = false) => {
    url = sanitizeUrl(url, appVersion);
    try {
      //console.log(`** routerPush: ${url} ${shallow}`);
      const didNavigate = await router.push(url, undefined, { shallow });
      if (!didNavigate) {
        // navigation was aborted (user hit Back, etc)
        console.warn('** Navigation to', url, 'was cancelled');
      }
      return didNavigate;
    } catch (err) {
      // log to Bugsnag and re-throw so callers can react
      logBugsnagError(err as Error, (event) => {
        event.addMetadata('Navigation', { type: 'push', url, appVersion });
      });
      throw err;
    }
  }, [router, appVersion]);

  // same for replace
  const routerReplace = React.useCallback(async (url: string, shallow = false) => {
    url = sanitizeUrl(url, appVersion);
    try {
      //console.log(`** routerReplace: ${url} ${shallow}`);
      const didNavigate = await router.replace(url, undefined, { shallow, scroll: false });
      if (!didNavigate) {
        console.warn('** Replace to', url, 'was cancelled');
      }
      return didNavigate;
    } catch (err) {
      // logBugsnagError(err as Error, (event) => {
      //   event.addMetadata('Navigation', { type: 'replace', url, appVersion });
      // });
      // throw err;
      return true;
    }
  }, [router, appVersion]);
  
  // same for replace
  const routerReplaceSync = React.useCallback((url: string, shallow = false) => {
    url = sanitizeUrl(url, appVersion);
    try {
      // console.log(`** routerReplace: ${url} ${shallow}`);
      router.replace(url, undefined, { shallow, scroll: false });
      return true;
    } catch (err) {
      // logBugsnagError(err as Error, (event) => {
      //   event.addMetadata('Navigation', { type: 'replace', url, appVersion });
      // });
      // throw err;
      return false;
    }
  }, [router, appVersion]);

  return [routerPush, routerReplace, routerReplaceSync, router.asPath];
}
